const SHOESITEM = [
  {
    id:'1',
    name:'오데마피게1',
    price:1200000,
    date: "2024-12-20",
    img: require('../assets/images/home/section2/4.jpg'),
    sellCount:10,
    delivery:0
  },
  {
    id:'2',
    name:'오데마피게2',
    price:1200000,
    date: "2024-12-19",
    img: require('../assets/images/home/section2/4.jpg'),
    sellCount:20,
    delivery:0
  },
  {
    id:'3',
    name:'오데마피게3',
    price:100000,
    date: "2024-12-18",
    img: require('../assets/images/home/section2/4.jpg'),
    sellCount:30,
    delivery:0
  },
  {
    id:'4',
    name:'오데마피게4',
    price:'1,000,000',
    date: "2024-12-17",
    img: require('../assets/images/home/section2/4.jpg'),
    sellCount:40,
    delivery:0
  },
  {
    id:'5',
    name:'오데마피게5',
    price:1200000,
    date: "2024-12-17",
    img: require('../assets/images/home/section2/4.jpg'),
    sellCount:50,
    delivery:0
  },
  {
    id:'6',
    name:'오데마피게6',
    price:1200000,
    date: "2024-12-17",
    img: require('../assets/images/home/section2/4.jpg'),
    sellCount:60,
    delivery:0
  },
]

export default SHOESITEM;